import type { Character } from "../types/character";
import { ALL_CHARACTERS } from "../types/character";
import type { CharacterRanking } from "../types/common";

export function calculateRankings(
  positions: Readonly<Record<Character, number>>,
): readonly CharacterRanking[] {
  const sorted = ALL_CHARACTERS.map((character) => ({
    character,
    position: positions[character],
  })).sort((a, b) => b.position - a.position);

  const rankings: CharacterRanking[] = [];
  let currentRank = 1;

  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i].position < sorted[i - 1].position) {
      currentRank = i + 1;
    }
    rankings.push({
      character: sorted[i].character,
      position: sorted[i].position,
      rank: currentRank,
    });
  }

  return rankings;
}

export function getTopThree(
  rankings: readonly CharacterRanking[],
): readonly CharacterRanking[] {
  return rankings.filter((r) => r.rank <= 3);
}
